<template lang="pug">
	.lineup(
		:class="{ 'is-editable': editable }"
	)
		.lineup-header
			figure.image.is-48x48
				img(:src="getMediaThumbnailURL(club.crest)")
			.lineup-title
				span.club {{ club.name }}
				span.desc Aufstellung
		draggable(
			v-model="draggableLineup"
			:disabled="!editable"
			handle=".section-handle"
		)
			.lineup-section(
				v-if="lineup"
				v-for="(section, sectionIndex) in lineup"
			)
				.section-players
					draggable.section-draggable(
						v-model="section.players"
						group="player"
						:disabled="!editable"
					)
						.lineup-row(
							v-for="(player, playerIndex) in section.players"
							:key="player._id"
						)
							span.player-number {{ player.number }}
							span.player-name {{ player.name }}
							span.player-icons
								span.player-action-icon(v-for="icon in getIconsForPlayer(player)")
									img(:src="icon", width="16" height="16")
							span.player-buttons(v-if="editable")
								b-icon(icon="times", @click.native="onClearPlayer(player, sectionIndex, playerIndex)")

				.section-actions.buttons(v-if="editable")
					.button.is-small.section-handle: b-icon(icon="arrows-v")
					.button.is-small(@click="onClearSection(section, sectionIndex)", :disabled="lineup.length === 1"): b-icon(icon="times")

</template>
<script>
import mediaMixin from '../mixins/mediaMixin'
import actionMixin from '../mixins/actionMixin'
import draggable from 'vuedraggable'

export default {
	mixins: [ mediaMixin, actionMixin ],
	components: {
		draggable
	},
	computed: {
	},
	props: {
		lineup: Array,
		club: Object,
		editable: Boolean,
		actions: {
			type: Object,
			required: false
		}
	},
	data () {
		return {
			internalLineup: []
		}
	},
	computed: {
		draggableLineup: {
			get () {
				return this.lineup
			},
			set (newLineup) {
				this.$emit('update:lineup', newLineup)
			}
		}
	},
	mounted () {
		if (this.lineup) {
			this.internalLineup = this.lineup
		}
	},
	methods: {
		onClearSection (section, index) {
			if (this.lineup.length <= 1) {
				return
			}
			this.$emit('clear-section', section, index)
		},
		onClearPlayer (player, sectionIndex, playerIndex) {
			this.$emit('clear-player', player, sectionIndex, playerIndex)
		},
		getIconsForPlayer (player) {
			if (!player || !player._id || !this.actions) { return [] }
			var actions = this.actions[player._id]
			if (actions === undefined || actions.length === 0) {
				return []
			}
			return actions.map(a => this.getIconForAction(a))
		}
	}


}
</script>

<style lang="scss" scoped>

	@import '@/assets/scss/bulma-variables.scss';

	.lineup {
		background: white;
		.lineup-header {
			display: flex;
			align-items: center;
			padding: 0.5em 1em;
			background: $primary;
			color: $white;

			figure {
				margin-right: 1em;
				margin-bottom: 0;
				margin-left: 0;
			}

			.lineup-title {
				display: flex;
				flex-direction: column;

				.club {
					font-weight: bold;
					font-size: 1.25em;
				}
			}
		}
		.lineup-section {
			position: relative;
			display: flex;
			&:not(:last-child) {
				border-bottom: 1px dashed rgba($dark, 0.5);
			}
			.section-draggable {
				min-height: 30px;
			}
			.section-players {
				flex-grow: 1;
			}
			.section-actions {
				background: $light;
				display: flex;
				align-items: center;
			}

			.button.clear-section {
				border: 1px dashed $dark;
				position: absolute;
				right: 0;
				top: 4px;
				min-height: 30px;
			}
		}
		.lineup-row  {
			padding: 0.25em 1em;
			border-bottom: 1px solid $light;
			display: flex;
			align-items: center;
			.player-number {
				display: inline-block;
				width: 25px;
				text-align: right;
			}

			.player-name {
				padding-left: 1em;
				flex-grow: 1;
			}

		}
		&.is-editable {
			.lineup-row  {
				&:hover {
					cursor: ns-resize;
				}
				.player-buttons {
					display: none;
					cursor: pointer;
					.icon {
						font-size: 12px;
						height: 1.25rem;
						&:hover {
							color: $secondary;
						}
					}
				}
				&:hover {
					.player-buttons {
						display: initial;
					}
				}
			}
		}
	}

</style>
